// Design tokens - centralized design values for the application
// This file contains all design constants that are used across the app
// Organized to be ready for Material Design 3 migration

// Typography tokens
export const typography = {
  fontFamily: {
    primary: 'ui-sans-serif,-apple-system,system-ui,Segoe UI,Helvetica,Apple Color Emoji,Arial,sans-serif,Segoe UI Emoji,Segoe UI Symbol',
  },
  fontSize: {
    xs: '0.7rem',
    sm: '0.75rem',
    base: '0.875rem',
    lg: '1rem',
    xl: '1.2rem',
  },
  fontWeight: {
    regular: 400,
    medium: 500,
    semibold: 600,
  },
  lineHeight: {
    tight: 1.25,
    normal: 1.5,
  },
  letterSpacing: {
    wide: '0.5px',
  },
};

// Spacing tokens
export const spacing = {
  xs: 0.25,
  sm: 0.5,
  base: 1,
  md: 1.5,
  lg: 2,
  xl: 3,
};

// Shape tokens
export const shape = {
  borderRadius: {
    xs: 2,
    sm: 4,
    base: 6,
    md: 8,
    full: '50%',
  },
};

// Elevation/Shadow tokens
export const elevation = {
  none: 'none',
  sm: '0 1px 3px #0000001a',
  base: '0 2px 5px #1976d226',
  md: '0 0 8px #ffffff1a',
  lg: '0px 0px 10px #0000001a',
  xl: '0px 0px 10px #00000080',
};

// Opacity tokens
export const opacity = {
  disabled: 0.5,
  hover: 0.8,
  active: 0.7,
  translucent: {
    xs: 0.02,
    sm: 0.04,
    base: 0.05,
    md: 0.08,
    lg: 0.1,
    xl: 0.15,
  },
};

// Animation/Transition tokens
export const animation = {
  duration: {
    fast: '0.2s',
    normal: '0.3s',
  },
  easing: {
    ease: 'ease',
    easeInOut: 'ease-in-out',
  },
};

// Component-specific tokens
export const components = {
  chatSession: {
    itemHeight: 40,
    padding: {
      vertical: 0.75,
      horizontal: 1,
    },
    margin: {
      vertical: 0.25,
    },
  },
  groupHeader: {
    padding: {
      top: 1,
      bottom: 0.5,
      horizontal: 2,
    },
    marginTop: 1,
  },
  menuButton: {
    height: 40,
    padding: {
      vertical: 0.75,
      horizontal: 1.5,
    },
    borderRadius: 8,
  },
  attachmentPreview: {
    size: {
      small: 64,
      medium: 96,
      large: 120,
    },
  },
  message: {
    padding: {
      content: 2,
      text: 5,
    },
    margin: {
      bottom: 1,
      paragraph: '0.75em',
    },
  },
};

// Layout tokens
export const layout = {
  sidebar: {
    width: {
      mobile: '100%',
      desktop: '100%',
    },
  },
  header: {
    height: 48,
  },
}; 